
export default {
  CARD: 'card'
}
